module.exports = __webpack_public_path__ + "static/media/landing-background-mobile.27ca0751.png";